import { devices } from 'src/stores/lists/devices';
import { pin_unlocked_devices } from 'src/stores/device-runtime/pin-unlocked';
import { get } from 'svelte/store';

const setTime = (delay, device, pinLocked) => {
	let timeout;
	const $devices = get(devices);
	clearTimeout(timeout);
	timeout = 0;
	pin_unlocked_devices.unlock_device(device);
	timeout = setTimeout(() => {
		pin_unlocked_devices.remove_device(device);
		return (pinLocked = $devices[device.id]?.pin_lock);
	}, delay);
	return (pinLocked = false);
};

export const unlockPin = (device, pinLocked, delay: number = 120000) => {
	return setTime(delay, device, pinLocked);
};
